import type { ReactNode } from 'react';

export function PageHeader({
  title,
  subtitle,
  actions,
}: {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}) {
  return (
    <div
      style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 20, flexWrap: 'wrap' }}
    >
      <div style={{ flex: 1, minWidth: 220 }}>
        <h1 className="t-h1">{title}</h1>
        {subtitle && (
          <div className="t-small dim" style={{ marginTop: 2 }}>
            {subtitle}
          </div>
        )}
      </div>
      {actions}
    </div>
  );
}
